/* Audit: drill-down mobile navigation */
(function () {
  var root = document.querySelector('[data-dm-mnav]');
  if (!root) return;
  var scroller = root.closest('.mobile-nav-panel');

  function openPanels() {
    return Array.prototype.slice.call(root.querySelectorAll('.dm-mnav__panel.is-open'));
  }
  function syncHeight() {
    var open = openPanels();
    var deepest = open[open.length - 1];
    root.classList.toggle('has-open', !!deepest);
    root.style.height = deepest ? deepest.scrollHeight + 'px' : '';
  }
  function closePanel(panel) {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    var trigger = root.querySelector('[data-dm-open="' + panel.id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }
  function resetAll() {
    openPanels().forEach(closePanel);
    syncHeight();
  }

  root.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-dm-toggle]');
    if (toggle) {
      e.preventDefault();
      var group = toggle.closest('[data-dm-group]');
      if (!group) return;
      var collapsed = group.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      return;
    }

    var opener = e.target.closest('[data-dm-open]');
    if (opener) {
      e.preventDefault();
      var panel = document.getElementById(opener.getAttribute('data-dm-open'));
      if (!panel) return;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      opener.setAttribute('aria-expanded', 'true');
      if (scroller) scroller.scrollTo({ top: 0 });
      syncHeight(); requestAnimationFrame(syncHeight); setTimeout(syncHeight, 350);
      var back = panel.querySelector('[data-dm-back]');
      if (back) back.focus({ preventScroll: true });
      return;
    }
    var backBtn = e.target.closest('[data-dm-back]');
    if (backBtn) {
      e.preventDefault();
      var p = backBtn.closest('.dm-mnav__panel');
      if (!p) return;
      closePanel(p);
      syncHeight(); requestAnimationFrame(syncHeight); setTimeout(syncHeight, 350);
      var trigger = root.querySelector('[data-dm-open="' + p.id + '"]');
      if (trigger) trigger.focus({ preventScroll: true });
    }
  });

  var nav = document.querySelector('[data-mobile-nav]');
  if (nav && window.MutationObserver) {
    new MutationObserver(function () {
      if (nav.getAttribute('data-open') !== 'true') resetAll();
    }).observe(nav, { attributes: true, attributeFilter: ['data-open'] });
  }
  window.addEventListener('resize', syncHeight);
})();
